import React from 'react'
import { PlusCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';

class DashedAddButton extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            bthStyle: {
                width: this.props.width ? this.props.width : '130px',
                height: this.props.height ? this.props.height : '130px'
            }
        }
    }

    render() {
        return (
            <Button type="dashed" className="dashed-add-button" onClick={this.props.onClick}
                    style={this.state.bthStyle}>
                <div className="dashed-add-cxt">
                    <PlusCircleOutlined />
                    <span>{this.props.addText}</span>
                </div>
            </Button>
        );
    }
}

export default DashedAddButton